import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetInstantOfferByIdSellerUseCase extends UseCase {
  constructor({instantOfferEntityFactory, localStorageRepository}) {
    super()

    this._instantOfferEntityFactory = instantOfferEntityFactory
    this._localStorageRepository = localStorageRepository
  }

  @tracer({metric: 'GetInstantOfferByIdSellerUseCase#execute'})
  @inlineError
  execute({instantOfferId} = {}) {
    const instantOfferEntity = this._instantOfferEntityFactory({instantOfferId})

    return this._localStorageRepository
      .getInstantOfferDetails({
        instantOfferEntity
      })
      .then(([error, instantOfferEntity]) => {
        if (error) return Promise.reject(error)
        return instantOfferEntity ? instantOfferEntity.toJSON() : null
      })
  }
}
